/* eslint-disable no-use-before-define */
import React from "react";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { makeStyles } from "@material-ui/core/styles";
import styled from "styled-components";
import variables from "styles/base/_universal.scss";
import { Paper } from "@material-ui/core";
import ExpandMore from "@material-ui/icons/ExpandMore";
//import "../styles/components/DropDownWithSearch.scss";
import Ibutton from "img/Ibutton.svg";
import Tooltip from "@material-ui/core/Tooltip";
import { withStyles } from "@material-ui/core/styles";
import CrossIcon from "img/croseicon.svg";

const DropDownWithSearch = (props) => {
  const { options } = props;
  const [showTooltip, setShowTooltip] = React.useState(false);

  const getValue = () => {
    if (options?.multiple) {
      return Array.isArray(options.value) ? options.value : [];
    }
    if (options && options.items && options.items.length > 0 && options.value) {
      if (options.isDataTypeObject) {
        // if (options?.label === "Primary Country") {
        //   console.log(options.value?.id, "testing 123456789");
        // }
        let selectedObject = options.items.find(
          (item) => item.id === options.value?.id,
        );

        if (!selectedObject) {
          selectedObject = options.items.find(
            (item) => item.veevaId === options.value?.veevaId,
          );
        }

        return selectedObject || null;
      } else {
        return options.items.includes(options.value) ? options.value : null;
      }
    }
    return null;
  };

  const handleSelection = (selectedValue) => {
    //const selectedValue = e.target.value;
    // const selectedObject = options.items?.find((item) => {
    //   return item.displayName === selectedValue;
    // });
    options.handleChange(selectedValue === null ? undefined : selectedValue);
  };

  const useStyles = makeStyles((theme) => ({
    popupIndicator: {
      "& span": {
        "& svg": {
          "& path": {
            d: "path('M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z')",
          },
        },
      },
    },
    paper: {
      // border: "5px solid black",
      overflowY: "hidden",
      fontSize: variables.fontSmall,

      "& MuiPaper-root": {
        overflowY: "hidden",
      },
    },
  }));
  const classes = useStyles();

  const CustomPaper = (props) => {
    return <Paper elevation={8} {...props} className="customScrollBar" />;
  };
  const iconComponent = (props) => {
    return !options.disabled && <ExpandMore className={props.className} />;
  };

  const Component = props.options.disabled
    ? DisabledAutoComplete
    : FilledAutoComplete;

  return (
    <Component
      //disabled={props.options.disabled}
      blurOnSelect={false}
      id="search-and-select"
      style={{ width: "100%" }}
      options={props?.options?.items || []}
      value={getValue()}
      onChange={(e, value) => {
        handleSelection(value);
      }}
      getOptionLabel={(option) => {
        return option?.displayName || "";
      }}
      disabled={props.options.disabled}
      multiple={props.options.multiple}
      closeIcon={
        <span
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            visibility:
              (Array.isArray(getValue())
                ? getValue().length > 0
                : !!getValue()) && !props.options.disabled
                ? "visible"
                : "hidden",
          }}
        >
          <img src={CrossIcon} alt="clear" className="clear-icon" />
        </span>
      }
      classes={{ paper: classes.paper, popupIndicator: classes.popupIndicator }}
      autoHighlight
      getOptionSelected={(option, value) => {
        if (value) {
          return option?.displayName === value?.displayName;
        }
        return false;
      }}
      PaperComponent={CustomPaper}
      getOptionDisabled={(option) => {
        return option?.isNotSelectable;
      }}
      renderOption={(option) => {
        return (
          <React.Fragment>
            <span className="display-name">{option.displayName}</span>
          </React.Fragment>
        );
      }}
      IconComponent={iconComponent}
      renderInput={(params) => (
        <TextField
          {...params}
          label={props.options.label}
          placeholder={props.options.placeholder}
          variant="filled"
          required={props.options.required || false}
          inputProps={{
            ...params.inputProps,
            autoComplete: "off", // "new-password" disable autocomplete and autofill
          }}
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <>
                {params.InputProps.endAdornment}
                {options.disabled && options.isDisabledDueToParent && (
                  <StyledTooltip
                    title={
                      <>
                        Select a{" "}
                        <span style={{ fontWeight: 900 }}>
                          {options.parentFieldName}
                        </span>{" "}
                        to enable <br />{" "}
                        <span style={{ fontWeight: 900 }}>
                          {options.currentFieldName}
                        </span>{" "}
                        dropdown
                      </>
                    }
                    open={showTooltip}
                    arrow
                    placement="bottom-end"
                  >
                    <InfoIconWrapper
                      onMouseOver={() => setShowTooltip(true)}
                      onMouseOut={() => setShowTooltip(false)}
                    >
                      <img src={Ibutton} alt="info" className="info-icon" />
                    </InfoIconWrapper>
                  </StyledTooltip>
                )}
              </>
            ),
          }}
        />
      )}
      ListboxProps={{
        className: "mui-popper customScrollBar",
      }}
    />
  );
};

const AutoCmplte = styled(Autocomplete)`
  margin-bottom: 16px !important;
`;

const FilledAutoComplete = styled(AutoCmplte)({
  "& .MuiFilledInput-root": {
    backgroundColor: `${variables.whiteColor}`,
    height: "42px",
    fontSize: `${variables.fontSmall}`,
    border: `solid 1px ${variables.borderColor}`,
    paddingRight: "0px !important",
    borderRadius: "6px",
    paddingBottom: "0px",
    paddingTop: "4px",
    paddingLeft: "11px",
    fontWeight: variables.fontWeight600,
  },
  "& .MuiInputAdornment-root": {
    display: "flex",
    alignItems: "center",
  },
  "& .MuiInputBase-adornedEnd": {
    "& .MuiInputAdornment-positionEnd": {
      display: "flex",
      alignItems: "center",
    },
  },
  "& .MuiAutocomplete-endAdornment": {
    display: "flex",
    alignItems: "center",
    //gap: "6px",
    top: "50%", // Center vertically
    transform: "translateY(-50%)",
    //top: "0",
    //bottom: "0",
    //height: "100%",
    //top: "50%", // Center vertically
    //transform: "translateY(-50%)",
    position: "absolute",
    right: "9px !important",
  },
  "& .MuiAutocomplete-clearIndicator": {
    padding: 0,
    marginRight: "6px", // Adjust spacing between cross and arrow
    marginBottom: "0px",
    marginTop: "0px",
    "& .clear-icon": {
      width: "8px",
      height: "8px",
    },
  },
  "& .MuiFormControl-root": {
    // marginTop: "16px",
  },

  "& .MuiFilledInput-root:hover": {
    backgroundColor: `${variables.whiteColor}`,
  },

  "& .MuiFilledInput-input": {
    //padding: 0;
    lineHeight: "4.5",
    height: "42px",
    transition: "none",
    paddingRight: "5px",
    padding: "0px !important",
    color: variables.searchTextColor,
  },
  "& .MuiInputLabel-formControl": {
    top: "-4px",
  },
  "& .MuiFilledInput-underline :focus": {
    borderBottom: "none",
  },
  "& .MuiFilledInput-underline:before": {
    borderBottom: "none",
  },
  "& .MuiFilledInput-underline:after": {
    borderBottom: "none",
  },
  "& .MuiFilledInput-underline:hover:before": {
    borderBottom: "none",
  },
  "& .MuiSelect-select:focus": {
    borderRadius: "6px",
  },
  "& .MuiInputLabel-filled.MuiInputLabel-shrink": {
    transform: " translate(9px, 15px) scale(0.75)",
  },
  "& .MuiInputBase-root.Mui-disabled": {
    border: "none !important",
  },
  "& .MuiFormLabel-asterisk": {
    color: "#e32b35",
  },
});

const DisabledAutoComplete = styled(FilledAutoComplete)({
  "& .MuiAutocomplete-endAdornment": {
    display: "flex !important",
    alignItems: "center",
    gap: "8px !important",
    position: "relative",
    top: "auto",
    transform: "none",
    paddingRight: "8px",
  },
  "& .MuiAutocomplete-popupIndicator": {
    display: "none !important",
  },
  "& .MuiFilledInput-input": {
    color: variables.subtitleColor,
  },
});

const StyledTooltip = withStyles({
  tooltip: {
    backgroundColor: "#fff",
    color: "#333",
    fontSize: "12px",
    padding: "8px 12px",
    borderRadius: "4px",
    whiteSpace: "normal",
    wordWrap: "break-word",
    lineHeight: "1.5",
    marginTop: "0px",
    marginRight: "18px",
    boxShadow: "0px 0px 8px 0px #231F201F",
  },
  arrow: {
    color: "#fff",
    width: "35px",
    height: "12px",
    paddingLeft: "9px",
    borderWidth: "2px",
    borderColor: "#fff",
    transform: "scale(1)",
  },
})(Tooltip);

const InfoIconWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-right: 8px;
  cursor: pointer;

  .info-icon {
    color: ${variables.infoIconColor || "rgba(0, 0, 0, 0.54)"};
    height: 12px;
    transition: color 0.2s ease;
    margin-bottom: 8px;

    &:hover {
      color: ${variables.infoIconHoverColor || "rgba(0, 0, 0, 0.87)"};
    }
  }
`;

export default DropDownWithSearch;
